import { useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { FileText, Share2, Mail, MessageSquare, X } from 'lucide-react';
import { noticePdf, noticeText } from '../lib/shutPdf';

const KEY = 'giss_notice';
const iso = (d) => new Date(d - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

// residents notice: PDF poster + share text (WhatsApp / e-mail / SMS) to affected house connections
export default function ShutNotice({ t, project, sh, onClose }) {
  const now = new Date();
  const [n, setN] = useState(() => ({ from: iso(now), to: iso(new Date(now.getTime() + 4 * 3600000)), reason: t.ntReasonDef, contact: '', phone: '', ...JSON.parse(localStorage.getItem(KEY) || '{}') }));
  const set = (k) => (e) => setN((x) => ({ ...x, [k]: e.target.value }));
  const keep = () => localStorage.setItem(KEY, JSON.stringify({ reason: n.reason, contact: n.contact, phone: n.phone }));
  const F = Object.fromEntries((project.fittings || []).map((f) => [f.id, f]));
  const hs = sh.houses.map((id) => F[id]).filter(Boolean);
  const mails = hs.map((f) => f.email).filter(Boolean), phones = hs.map((f) => f.phone).filter(Boolean);
  const text = noticeText(t, n);
  const share = async () => {
    keep();
    if (navigator.share) { try { await navigator.share({ title: t.ntHead, text }); } catch { /* cancelled */ } return; }
    await navigator.clipboard?.writeText(text);
    toast.success(t.ntCopied);
  };
  const go = (url) => { keep(); window.location.href = url; };
  return createPortal(
    <div className="editor-backdrop" data-testid="notice-dialog">
      <div className="editor nt-box">
        <div className="sh-head"><b>{t.ntBtn}</b><button className="icon-btn" data-testid="notice-close-btn" onClick={onClose}><X size={18} /></button></div>
        <label>{t.ntFrom}<input type="datetime-local" data-testid="notice-from" value={n.from} onChange={set('from')} /></label>
        <label>{t.ntTo}<input type="datetime-local" data-testid="notice-to" value={n.to} onChange={set('to')} /></label>
        <label>{t.ntReason}<input data-testid="notice-reason" value={n.reason} onChange={set('reason')} /></label>
        <label>{t.ntContact}<input data-testid="notice-contact" value={n.contact} placeholder={t.ntContactPh} onChange={set('contact')} /></label>
        <label>{t.ntPhone}<input type="tel" data-testid="notice-phone" value={n.phone} onChange={set('phone')} /></label>
        <p className="muted" data-testid="notice-recipients">{t.ntRecip.replace('{h}', hs.length).replace('{m}', mails.length).replace('{p}', phones.length)}</p>
        <div className="row prec-btns">
          <button className="btn btn-red" data-testid="notice-pdf-btn" onClick={() => { keep(); noticePdf(t, project, sh, n); }}><FileText size={16} /> {t.ntPdf}</button>
          <button className="btn btn-green" data-testid="notice-share-btn" onClick={share}><Share2 size={16} /> {t.ntShare}</button>
          {mails.length > 0 && <button className="btn btn-dark" data-testid="notice-mail-btn" onClick={() => go(`mailto:?bcc=${encodeURIComponent(mails.join(','))}&subject=${encodeURIComponent(t.ntHead)}&body=${encodeURIComponent(text)}`)}><Mail size={16} /> {t.ntMail}</button>}
          {phones.length > 0 && <button className="btn btn-outline" data-testid="notice-sms-btn" onClick={() => go(`sms:${phones.join(',')}?&body=${encodeURIComponent(text)}`)}><MessageSquare size={16} /> SMS</button>}
        </div>
      </div>
    </div>,
    document.body,
  );
}
